import script from "./InputGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputGroup.vue?vue&type=script&setup=true&lang=ts"

import "./InputGroup.vue?vue&type=style&index=0&id=4629af12&lang=scss"

const __exports__ = script;

export default __exports__